import Label from './label';
import './label.scss';

export default Label;
